import React from 'react';
import formatHands from '../../utils/formatHands';
import type { PostflopTableData } from '../utils/postflopBuilders';

type V2PostflopTableProps = {
  table: PostflopTableData;
  ariaLabel: string;
  variant?: 'default' | 'matrix';
};

const PREFLOP_ROW_HINTS: Record<string, string> = {
  R1: 'Open raise',
  F3b: 'Fold vs 3bet',
  C3b: 'Call 3bet',
  C3br: 'Call 3bet + raise',
  '4bet': '4bet',
  '4br': '4bet + raise',
  F5b: 'Fold vs 5bet',
  ISO1: 'Iso-raise vs 1 limper',
  ISO2: 'Iso-raise vs 2 limpers',
  ISO3: 'Iso-raise vs 3 limpers',
  Limp: 'Limp',
  'L-F': 'Limp-fold',
  'L-R': 'Limp-raise',
};

const shouldShowSample = (sample?: number | null) => typeof sample === 'number' && sample < 99;

const V2PostflopTable: React.FC<V2PostflopTableProps> = ({
  table,
  ariaLabel,
  variant = 'default',
}) => (
  <div className="table-scroll" tabIndex={0} role="region" aria-label={ariaLabel}>
    <table className={`postflop-table${variant === 'matrix' ? ' postflop-table--matrix' : ''}`}>
      <thead>
        <tr>
          <th scope="col">{table.streetColumnLabel}</th>
          {table.heads.map((head) => (
            <th key={head} scope="col">
              {head}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {table.rows.map((row) => (
          <tr key={row.label}>
            <th scope="row" title={row.title ?? PREFLOP_ROW_HINTS[row.label]}>
              {row.label}
            </th>
            {row.cells.map((cell, index) => (
              <td key={`${row.label}-${index}`}>
                <span className="postflop-value-wrap">
                  <span className="postflop-value-body">
                    <span className="postflop-cell-value">{cell.value ?? '—'}</span>
                    {shouldShowSample(cell.sample) ? (
                      <span className="postflop-sample" title={`Выборка: ${cell.sample}`}>
                        {formatHands(cell.sample!, 0)}
                      </span>
                    ) : null}
                  </span>
                </span>
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default V2PostflopTable;
